import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, AbstractControlDirective, FormControl } from '@angular/forms';
import { MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatSelectChange } from '@angular/material/select';

export declare interface SelectOption {
  label: string;
  value: any;
  disabled?: boolean;
  level?: number;
  parent?: number;
  isParent?: number[];
  parentId?: number;
}

export declare interface SelectOptGroup {
  label: string;
  items: SelectOption[];
}

export declare interface Select extends SelectOption, SelectOptGroup { }

@Component({
  selector: 'iv-select',
  templateUrl: './iv-select.component.html',
  styleUrls: ['./iv-select.component.scss']
})
export class IvSelectComponent implements OnChanges, AfterViewInit {
  @Input() name: string = 'ivselect_name';
  @Input() mode: string = 'standard';
  @Input() hidden: boolean;
  @Input() width: string = '';
  @Input() label: string = '';
  @Input() search: boolean = true;
  @Input() value: any = null;
  @Input() formControl: FormControl = new FormControl(this.value);
  @Input() multiple: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() disabled: boolean = false;
  @Input() multiLevel: boolean = false;
  @Input() groups: boolean = false;
  @Input() data: Select[] = [];
  @Input() selectClass: string = '';
  @Input() required: boolean = false;
  @Input() inputDisabled: boolean = false;
  @Input() errors: { [key: string]: string } = {
    'required': 'Este campo es requerido.'
  }
  newArray: any[] = [];
  parents: Select[] = [];
  childs: Select[] = [];
  areasSelect: boolean = false;
  options: Select[] = this.data;
  initial: boolean = false;
  query: string = '';
  top: number = 62 + 42;
  level: number = 0;
  selectedValue: unknown;

  private control: AbstractControlDirective | AbstractControl;
  openPanel: boolean;

  @Output() selectionChange: EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();
  @Output() valueChange: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() inputChange: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() iconClick = new EventEmitter();
  @Input('columnsAdvancedSearch') columnsAdvancedSearch;
  @Input('onSearchClick') onSearchClick;

  @ViewChild('searchInput', { static: false }) searchInput: MatInput;
  @ViewChild('select', { static: false }) select: MatSelect;

  change(event: MatSelectChange) {
    if (this.multiple && !this.groups) {
      let found = this.newArray.find(res => res === this.selectedValue);
      if (found) {
        let clean = this.newArray.findIndex(item => item === found);
        this.newArray.splice(clean, 1);
      }
      this.value = event.value;
      for (let i_1 = 0; i_1 < this.value.length; i_1++) {
        let nuevo = this.value[i_1];
        this.newArray.push(nuevo);
      }
      for (let i = this.newArray.length - 1; i >= 0; i--) {
        if (this.newArray.indexOf(this.newArray[i]) !== i) {
          this.newArray.splice(i, 1);
        }
      }
      event.value = this.newArray
      this.formControl.patchValue(event.value);
      this.selectionChange.emit(event);
      this.valueChange.emit(this.value);
      if (this.select.triggerValue.includes('subdirectory_arrow_right')) {
        this.select.customTrigger = this.select.triggerValue.replace('subdirectory_arrow_right', '');
        this.select.trigger.nativeElement.textContent = this.select.customTrigger;
      }
      this.value = this.newArray;
    } else {
      this.value = event.value;
      this.formControl.patchValue(event.value);
      this.selectionChange.emit(event);
      this.valueChange.emit(this.value);
      if (this.select.triggerValue.includes('subdirectory_arrow_right')) {
        this.select.customTrigger = this.select.triggerValue.replace('subdirectory_arrow_right', '');
        this.select.trigger.nativeElement.textContent = this.select.customTrigger;
      }
    }
  }

  ngAfterViewInit(): void {
    this.select._openedStream.subscribe((response) => {
      this.openPanel = true;
    });
    this.select._closedStream.subscribe((response) => {
      this.openPanel = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.data?.forEach(element => {
      if (element.level > 0) {
        this.areasSelect = true;
      }
    })
    this.reSizerBefore();
    if (changes.data && changes.data.currentValue !== changes.data.previousValue) {
      this.data.sort(function (a, b) {
        if ((a.label && b.label) !== 'Ninguno')
          return a.label?.localeCompare(b.label);
      });
      this.reSizerAfter();
      this.options = this.data;
      this.initial = true;
    }
    if (changes.value && changes.value.currentValue !== changes.value.previousValue) {
      if (this.value != this.formControl.value) {
        this.formControl.setValue(this.value);
      }
    }
  }

  reSizerBefore() {
    if (this.areasSelect) {
      this.data?.forEach((area) => {
        if (area.level > 0) {
          this.childs.push(area);
        }
        else {
          this.parents.push(area);
        }
        this.data = this.parents;
      })
    }
  }

  reSizerAfter() {
    if (this.areasSelect) {
      if (this.childs.length > 0) {
        this.childs?.forEach(child => {
          const idParent = this.data.findIndex(parent => parent.value === child.parentId);
          if (idParent) {
            this.data.splice(idParent + 1, 0, child);
          }
        })
      }
    }
  }


  showtooltip(option: MatOption) {
    const element = document.getElementById(option.id);
    let parentWidth: number;
    let textWidth: number;
    if (element) {
      if (this.multiple) {
        parentWidth = (<HTMLElement>element.firstElementChild.nextElementSibling).offsetWidth;
        textWidth = (<HTMLElement>element.firstElementChild.nextElementSibling.firstElementChild).offsetWidth;
      } else {
        parentWidth = (<HTMLElement>element.firstElementChild).offsetWidth;
        textWidth = (<HTMLElement>element.firstElementChild.firstElementChild).offsetWidth;
      }
      if (textWidth > parentWidth) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  filter() {
    this.newArray = this.formControl.value;
    const q = this.query.trim().toLowerCase();
    this.inputChange.emit(q);
    if (!q) {
      this.options = this.data;
      return;
    }
    let temp: Select[] = [];
    if (this.groups) {
      temp = this.filterGroups(q);
    } else {
      temp = this.filterNonGroups(q);
    }
    this.options = temp;
  }

  private filterGroups(q: string): Select[] {
    const temp: Select[] = [];
    for (let i = 0; i < this.data.length; i++) {
      const opts: SelectOption[] = this.filterGroupItems(this.data[i].items, q);
      if (opts.length) {
        let group: Select = { ...this.data[i], items: opts };
        temp.push(group);
      }
    }
    return temp;
  }

  private filterGroupItems(items: SelectOption[], q: string): SelectOption[] {
    return items.filter(item => item.label.toLowerCase().indexOf(q) !== -1);
  }

  private filterNonGroups(q: string): Select[] {
    const temp: Select[] = [];
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].label.toLowerCase().indexOf(q) !== -1) {
        this.addParent(temp, i);
      }
    }
    return temp;
  }

  addParent(temp: Select[], i: number) {
    if (this.data[i].level) {
      this.multiLevel = true;
      this.data?.forEach((element, index) => {
        if (element.value === this.data[i].parentId) {
          this.addParent(temp, index);
        }
      });
    }
    if (temp.indexOf(this.data[i]) == -1) {
      temp.push(this.data[i]);
    }
    if (this.data[i].isParent) {
      const parentId = this.data[i].value;
      let ch = this.data.filter(
        element => {
          if (parentId === element.parentId && temp.indexOf(element) == -1 && element.isParent) {
            temp.push(element);
            this.addChild(element.value, temp);
          }
          return parentId === element.parentId && temp.indexOf(element) == -1;
        }
      );
      Array.prototype.push.apply(temp, ch);
    }
  }


  addChild(parentId: number, temp: Select[]) {
    let addChild;
    this.data?.forEach(element => {
      if (parentId === element.parentId && temp.indexOf(element) == -1) {
        addChild = element;
        temp.push(addChild);
        if (element.isParent) {
          this.addChild(element.value, temp);
        }
      }
      return parentId === element.parentId && temp.indexOf(element) == -1;
    });
  }

  onOptionSelected(event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      this.selectedValue = event.source.value;
    }
    if (this.select.triggerValue.includes('subdirectory_arrow_right')) {
      this.select.customTrigger = this.select.triggerValue.replace('subdirectory_arrow_right', '');
      this.select.trigger.nativeElement.textContent = this.select.customTrigger;
    }
  }

  openedChange(event: MatSelectChange) {
    if (this.search) {
      if (!event) {
        this.query = '';
        this.filter();
      } else {
        this.searchInput.focus();
      }
    }
    let int = setInterval(
      () => {
        let doc = document.getElementsByClassName(this.name);
        if (doc.length) {
          clearInterval(int);
        }
      }, 100
    );
  }

  getErrorMessage() {
    this.control = this.formControl;
    if (!this.control) {
      return false;
    }
    return this.control.errors ? Object.keys(this.control.errors).map(field => this.errors[field]) : false;
  }

  onIconClick(event: MouseEvent) {
    this.iconClick.emit(event)
  }
}
